// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__oxwLg","productName":"Table_productName__1kF-4"};